module.exports = __webpack_public_path__ + "static/media/04-galeria-01-perisur-mobile@2x.b11c4e91.jpg";